import { render, staticRenderFns } from "./Notifications.vue?vue&type=template&id=2cd7fd25"
import script from "./Notifications.js?vue&type=script&lang=js&external"
export * from "./Notifications.js?vue&type=script&lang=js&external"
import style0 from "./Notifications.vue?vue&type=style&index=0&id=2cd7fd25&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports